import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class OrigenService
{
    constructor() {
    }

    getOrigin()
    {
        //let origenUrl = 'padres.scholaegt.com'; //TEST PADRES
        //let origenUrl = 'colegio.demoestudiantes.scholaegt.com'; //TEST ESTUDIANTE
        let origenUrl = location.origin;
        origenUrl = origenUrl.replace('https://', '').replace('http://', '').replace('.scholaegt.com', '');
        const arrOrigen = origenUrl.split('.');
        const blnPadre = ["padres", "demopadres"].includes(arrOrigen[0]);
        return { origen: origenUrl, padre: blnPadre };
    }

}